export default {
  methods: {
    //DISPATCHES
    setError(err, prevent, actionEv) {
      const debugInfo = {
        code: err?.code,
        message: err?.message,
        method: err?.config?.method?.toUpperCase?.() || err?.config?.method,
        url: err?.config?.url,
        status: err?.response?.status,
        statusText: err?.response?.statusText,
        data: err?.response?.data,
      }
      console.error("[Backend/API Error] Request failed", debugInfo, err)

      const status = err?.response?.status;

      if (!status || status >= 500) {
        err = {
          response: {
            status: "500",
            statusText: "server_error",
          },
        };
      }
      const response = err?.response;
      document.dispatchEvent(
        new CustomEvent("error-" + response.status, {
          detail: {
            preventDefault: Boolean(prevent),
            callbackEvent: actionEv,
            data: response,
          },
        }),
      );
    },
  },
};
